module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gridContainer",
    staticClass: "grid-container",
    style: (_vm.gridStyle)
  }, [(this.dragAreas) ? _vm._l((_vm.dragAreas), function(item, index) {
    return _c('grid-item', {
      key: item.label,
      attrs: {
        "item": item
      }
    })
  }) : _vm._l((_vm.areas), function(item, index) {
    return _c('grid-item', {
      key: item.label,
      attrs: {
        "item": item
      },
      on: {
        "dragStart": _vm.dragStart,
        "dragUpdate": _vm.dragUpdate,
        "dragEnd": _vm.dragEnd,
        "resizeStart": _vm.resizeStart,
        "resizeUpdate": _vm.resizeUpdate,
        "resizeEnd": _vm.resizeEnd
      }
    })
  }), _vm._v(" "), (_vm.dragging.item) ? _c('grid-item', {
    key: 'placeholder',
    attrs: {
      "item": _vm.placeholder
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6806ed02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GridContainer.vue
// module id = 74
// module chunks = 1